// Country list with destination region for CaminoSapiens checkout.
// region: "US" (United States) | "EU" (Europe/EEA) | "OTHER" (Rest of World)
export const COUNTRIES = [
  { code: "US", name: "United States", region: "US" },
  // Europe / EEA
  { code: "AT", name: "Austria", region: "EU" },
  { code: "BE", name: "Belgium", region: "EU" },
  { code: "BG", name: "Bulgaria", region: "EU" },
  { code: "HR", name: "Croatia", region: "EU" },
  { code: "CY", name: "Cyprus", region: "EU" },
  { code: "CZ", name: "Czechia", region: "EU" },
  { code: "DK", name: "Denmark", region: "EU" },
  { code: "EE", name: "Estonia", region: "EU" },
  { code: "FI", name: "Finland", region: "EU" },
  { code: "FR", name: "France", region: "EU" },
  { code: "DE", name: "Germany", region: "EU" },
  { code: "GR", name: "Greece", region: "EU" },
  { code: "HU", name: "Hungary", region: "EU" },
  { code: "IS", name: "Iceland", region: "EU" },
  { code: "IE", name: "Ireland", region: "EU" },
  { code: "IT", name: "Italy", region: "EU" },
  { code: "LV", name: "Latvia", region: "EU" },
  { code: "LI", name: "Liechtenstein", region: "EU" },
  { code: "LT", name: "Lithuania", region: "EU" },
  { code: "LU", name: "Luxembourg", region: "EU" },
  { code: "MT", name: "Malta", region: "EU" },
  { code: "NL", name: "Netherlands", region: "EU" },
  { code: "NO", name: "Norway", region: "EU" },
  { code: "PL", name: "Poland", region: "EU" },
  { code: "PT", name: "Portugal", region: "EU" },
  { code: "RO", name: "Romania", region: "EU" },
  { code: "SK", name: "Slovakia", region: "EU" },
  { code: "SI", name: "Slovenia", region: "EU" },
  { code: "ES", name: "Spain", region: "EU" },
  { code: "SE", name: "Sweden", region: "EU" },
  { code: "CH", name: "Switzerland", region: "EU" },
  { code: "GB", name: "United Kingdom", region: "EU" },
  // Rest of World
  { code: "AR", name: "Argentina", region: "OTHER" },
  { code: "AU", name: "Australia", region: "OTHER" },
  { code: "BR", name: "Brazil", region: "OTHER" },
  { code: "CA", name: "Canada", region: "OTHER" },
  { code: "CL", name: "Chile", region: "OTHER" },
  { code: "CN", name: "China", region: "OTHER" },
  { code: "HK", name: "Hong Kong", region: "OTHER" },
  { code: "IN", name: "India", region: "OTHER" },
  { code: "ID", name: "Indonesia", region: "OTHER" },
  { code: "IL", name: "Israel", region: "OTHER" },
  { code: "JP", name: "Japan", region: "OTHER" },
  { code: "MY", name: "Malaysia", region: "OTHER" },
  { code: "MX", name: "Mexico", region: "OTHER" },
  { code: "NZ", name: "New Zealand", region: "OTHER" },
  { code: "PH", name: "Philippines", region: "OTHER" },
  { code: "SG", name: "Singapore", region: "OTHER" },
  { code: "ZA", name: "South Africa", region: "OTHER" },
  { code: "KR", name: "South Korea", region: "OTHER" },
  { code: "TW", name: "Taiwan", region: "OTHER" },
  { code: "TH", name: "Thailand", region: "OTHER" },
  { code: "AE", name: "United Arab Emirates", region: "OTHER" },
  { code: "OTHER", name: "Other country", region: "OTHER" },
];

export const regionOfCountry = (code) => COUNTRIES.find((c) => c.code === code)?.region || null;
// Countries where a state/province/region is expected.
export const STATE_REQUIRED = new Set(["US", "CA", "AU"]);
